export default {
  allTractVisitTypes: (state) => state.tractVisitTypes,
  tractVisitTypesLoading: (state) => state.loading
}
